// Shared helpers for the SOW pickers (milestone / deliverable SOW filter
// chips and the scope-selector dropdown). Long prod SOW registers carry
// long names, so above SOW_SEARCH_THRESHOLD options the pickers render a
// text search; matching and ordering live here so all pickers behave
// identically (and identically to the variation-target picker's
// searchable checklist, which set the convention).

/** Above this many selectable SOWs a picker shows its search input —
 *  same threshold as the variation-target picker's searchable
 *  checklist. */
export const SOW_SEARCH_THRESHOLD = 8;

/** Case-insensitive trimmed-substring match. An empty (or whitespace)
 *  query matches everything so the unfiltered list renders unchanged. */
export function matchesSowSearch(text: string, query: string): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  return text.toLowerCase().includes(q);
}

/** Natural-ascending SOW-number compare (numeric-aware, so `2` < `10`
 *  and `SOW-2026-002` < `SOW-2026-010`). Matches the ordering users see
 *  in the variation-target picker. */
export function compareSowNumbers(a: string, b: string): number {
  return a.localeCompare(b, undefined, {
    numeric: true,
    sensitivity: "base",
  });
}
